import { createAction, props } from '@ngrx/store';
import { IContentStats } from 'lingo2-models';

export const requestFail = createAction('[Constructor] Stats request: fail', props<{ error: string }>());

export const loadStats = createAction('[Constructor] Load stats');
export const loadStatsSuccess = createAction('[Constructor] Load stats: success', props<{ stats: IContentStats }>());
